import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackAddToCart, trackInitiateCheckout, trackLead } from '../utils/pixel';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  isExternal?: boolean;
  className?: string;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text,
  subtext,
  isExternal = false,
  className = ''
}) => {
  const handleClick = () => {
    trackAddToCart();
    trackInitiateCheckout();
    window.location.href = 'https://valordigital.store/cart/46518849142973:1';
  };
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-411">
      <button onClick={handleClick} className="group relative w-full max-w-xl bg-coral hover:bg-coral-light text-white font-montserrat font-black text-xl md:text-3xl py-5 px-6 md:px-8 rounded-xl shadow-[0_8px_0px_#B83A2A] active:translate-y-[8px] active:shadow-none transition-all flex flex-col items-center justify-center border-2 border-white/20" data-id="element-412">
        <div className="flex items-center gap-3 text-center" data-id="element-413">
          <span className="uppercase tracking-wide" data-id="element-414">{text}</span>
          <ArrowRight className="w-6 h-6 md:w-8 md:h-8 group-hover:translate-x-2 transition-transform hidden sm:block" data-id="element-415" />
        </div>
        {subtext && <span className="text-sm md:text-base font-opensans font-normal mt-2 text-white/90 text-center" data-id="element-416">
            {subtext}
          </span>}
      </button>
    </div>;
};
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
}
export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  id,
  dark = false
}) => {
  return <section id={id} className={`py-16 md:py-24 px-4 ${dark ? 'bg-black text-white' : 'bg-white text-black'} ${className}`} data-id="element-417">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-5xl mx-auto" data-id="element-418">
        {children}
      </motion.div>
    </section>;
};